import { cn } from '@/lib/utils';

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
  children?: React.ReactNode;
}

export function Progress({ className, value = 0, children, ...props }: ProgressProps) {
  return (
    <div
      className={cn(
        'relative h-2 w-full overflow-hidden rounded-full bg-gray-800',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
